<div class="form-control form-control__icon">
  <div class="ds-icon ds-icon--big ds-icon--{{iconName}}"></div>
</div>
